
import axios from '@/axios.js'

export default {

  getUserLessonScreens({commit, state}, uuid) {
    return new Promise((resolve, reject) => {
      axios.get(`/lessons/${uuid}/lesson-screens`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getUserLessonScreen({commit, state}, {trainingUuid, screenUuid}) {
    return new Promise((resolve, reject) => {
      axios.get(`/lesson-screens/${screenUuid}`, {params: {training: trainingUuid }})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  completeUserLessonScreen({commit, state}, uuid) {
    return new Promise((resolve, reject) => {
      axios.patch(`/lesson-screens/${uuid}/complete`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  sendRecordTime(state, {trainingUuid, interval}) {
    console.log(trainingUuid);
    return new Promise((resolve, reject) => {
      axios.patch(`/trainings/${trainingUuid}`, {interval: interval})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

}
